<!--<img-->
<!--    fxShow-->
<!--    fxShow.gt-xs="false"-->
<!--    fxFlexAlign="flex-start"-->
<!--    fxLayout="column"-->
<!--    (click)="backButton()"-->
<!--    class="back-button"-->
<!--    style="margin: 0 0 0 17px; position: inherit;"-->
<!--    src="https://images.dailyobjects.com/icons/arrow.png"-->
<!--/>-->
<div
    *ngIf="innerWidth > 768 ? true : false"
    fxShow
    fxShow.xs="false"
    fxLayout="column"
    fxLayoutAlign="center center"
    style="background-color: #cecece99; overflow: hidden"
>
    <div class="page-desktop login">
        <div fxLayoutAlign="space-between">
            <h1 class="page-title">LOGIN</h1>
            <img
                fxHide.xs
                [ngStyle.gt-xs]="{ display: !isPagePopup ? 'none' : 'initial' }"
                (click)="dialogRef.close()"
                style="cursor: pointer"
                src="https://images.dailyobjects.com/icons/cross.png"
                class="icon"
        /></div>
        <p
            >Please enter your
            <span class="phn-number">{{
                this.authConfig.mechanism.label
            }}</span>
            to receive the OTP</p
        >
        <form fxLayout="column">
            <mat-form-field class="form" color="primary" appearance="outline">
                <span
                    [ngStyle]="{
                        color: 'black'
                    }"
                    matPrefix
                    >{{ authConfig.mechanism.prefix }} &nbsp;</span
                >
                <input
                    matInput
                    autofocus
                    [pattern]="this.authConfig.mechanism.pattern"
                    [type]="this.authConfig.mechanism.type"
                    [formControl]="identifier"
                    [maxLength]="this.authConfig.mechanism.maxLength"
                    (keypress)="
                        keyPressNumbers($event, this.authConfig.mechanism.type)
                    "
                    autocomplete="on"
                    (keyup)="
                        !identifier?.errors?.pattern &&
                        identifier?.value?.toString().length === 10 &&
                        ($event.code === 'Enter' ||
                            $event.keyCode === 13 ||
                            $event.code === 'enter')
                            ? processLink('/fn/?action=generate-otp')
                            : ''
                    "
                    [ngStyle]="{
                        color: 'black'
                    }"
                />
                <mat-error class="wrong-no" *ngIf="!!wrongNumber">{{
                    wrongNumber
                }}</mat-error>
            </mat-form-field>
        </form>
        <p style="margin: 0px 0 32px 0"
            >By continuing, I agree to the
            <a
                ><span
                    class="term"
                    (click)="processLink('/gp?f=page~static,type~termsOfUse')"
                    >Terms of Use</span
                ></a
            >
            and
            <a routerLink="/privacy-and-security-policy"
                ><span class="term">Privacy Policy</span></a
            >
        </p>
        <button
            [disabled]="
                identifier?.errors?.pattern ||
                identifier?.value?.toString().length === 0 ||
                loading
            "
            color="primary"
            style="border-radius: 0"
            (click)="processLink('/fn/?action=generate-otp')"
            mat-raised-button
            class="call-to-action-button send-otp"
        >
            GET OTP
        </button>
    </div>
</div>

<div *ngIf="innerWidth <= 768 ? true : false" class="page login">
    <div fxLayoutAlign="space-between">
        <h1 class="page-title">LOGIN</h1>
        <img
            fxHide.xs
            [ngStyle.gt-xs]="{ display: !isPagePopup ? 'none' : 'initial' }"
            (click)="dialogRef.close()"
            style="cursor: pointer"
            src="https://images.dailyobjects.com/icons/cross.png"
            class="icon"
    /></div>
    <p
        >Please enter your
        <span class="phn-number">{{ this.authConfig.mechanism.label }}</span> to
        receive the OTP</p
    >
    <form fxLayout="column">
        <mat-form-field class="form" color="primary" appearance="outline">
            <span
                [ngStyle]="{
                    color: 'black'
                }"
                matPrefix
                >{{ authConfig.mechanism.prefix }} &nbsp;</span
            >
            <input
                autofocus
                matInput
                [pattern]="this.authConfig.mechanism.pattern"
                [type]="this.authConfig.mechanism.type"
                [formControl]="identifier"
                [maxLength]="this.authConfig.mechanism.maxLength"
                (keypress)="
                    keyPressNumbers($event, this.authConfig.mechanism.type)
                "
                autocomplete="on"
                (keyup)="
                    !identifier?.errors?.pattern &&
                    identifier?.value?.toString().length === 10 &&
                    ($event.code === 'Enter' ||
                        $event.keyCode === 13 ||
                        $event.code === 'enter')
                        ? processLink('/fn/?action=generate-otp')
                        : ''
                "
                [ngStyle]="{
                    color: 'black'
                }"
            />
            <mat-error class="wrong-no" *ngIf="!!wrongNumber">{{
                wrongNumber
            }}</mat-error>
        </mat-form-field>
    </form>
    <p style="margin: 0px 0 32px 0"
        >By continuing, I agree to the
        <a (click)="processLink('/gp?f=page~static,type~termsOfUse')"
            ><span class="term">Terms of Use</span></a
        >
        and
        <a routerLink="/privacy-and-security-policy"
            ><span class="term">Privacy Policy</span></a
        >
    </p>
    <button
        [disabled]="
            identifier?.errors?.pattern ||
            identifier?.value?.toString().length === 0 ||
            loading
        "
        color="primary"
        style="border-radius: 0"
        (click)="processLink('/fn/?action=generate-otp')"
        mat-raised-button
        class="call-to-action-button send-otp"
    >
        GET OTP
    </button>
</div>
<mat-progress-spinner
    fxShow="true"
    *ngIf="loading"
    class="page-spinner"
    mode="indeterminate"
    diameter="40"
    strokeWidth="5"
    value="5"
></mat-progress-spinner>
